import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-section-edit',
  templateUrl: './section-edit.component.html',
  styleUrls: ['./section-edit.component.css']
})
export class SectionEditComponent implements OnInit {
  accId: any;
  templateId: any;
  api_error: string;
  api_success: string;
  templateDetailId: any;
  btndisabled = false;
  templateDetails: any = [];
  sectionType_list: any = [
    {
      "displayName": "USERDEFINED",
      "value": "USERDEFINED"
    },
    {
      "displayName": "CHIEFCOMPLAINT",
      "value": "CHIEFCOMPLAINT"
    },
    {
      "displayName": "HISTORY",
      "value": "HISTORY"
    },
    {
      "displayName": "DENTALHISTORY",
      "value": "DENTALHISTORY"
    },
    {
      "displayName": "MEDICATION",
      "value": "MEDICATION"
    },
    {
      "displayName": "VITALSIGNS",
      "value": "VITALSIGNS"
    },
    {
      "displayName": "ALLERGIES",
      "value": "ALLERGIES"
    },
    {
      "displayName": "ORALEXAMINATION",
      "value": "ORALEXAMINATION"
    },
    {
      "displayName": "IMMUNIZATIONHISTORY",
      "value": "IMMUNIZATIONHISTORY"
    },
    {
      "displayName": "OBSERVATIONS",
      "value": "OBSERVATIONS"
    },
    {
      "displayName": "DIAGNOSIS",
      "value": "DIAGNOSIS"
    },
    {
      "displayName": "NOTES",
      "value": "NOTES"
    },
    {
      "displayName": "INVESTIGATIONS",
      "value": "INVESTIGATIONS"
    },
    {
      "displayName": "LABORDER",
      "value": "LABORDER"
    },
    {
      "displayName": "LABTEST",
      "value": "LABTEST"
    },
    {
      "displayName": "PRESCRIPTION",
      "value": "PRESCRIPTION"
    },
    {
      "displayName": "TOOTHS",
      "value": "TOOTHS"
    },
    {
      "displayName": "TREATMENTPLAN",
      "value": "TREATMENTPLAN"
    }
  ]
  public sectionForm: UntypedFormGroup;
  templeteDetailId: any;
  jsonData: string;
  JsonObject;
  type: any;
  action;
  tempId: any;
  isJsonValid: boolean = false;
  JsonObject1;
  testJson: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: number,
    private matDialog: MatDialogRef<any>,
    private formbuilder: UntypedFormBuilder,
    private accountService: AccountService) { }
  ngOnInit(): void {
    this.createForm();
    this.accId = this.data['accountId'];
    this.templateDetailId = this.data['templatedetailId'];
    this.type = this.data['type'];
    this.tempId = this.data['tempId'];
    if (this.type === 'edit') {
      this.action = 'Update';
      if (this.accId) {
        this.getTemplateDetailsById(this.accId, this.templateDetailId);
      }
    }
    else {
      this.action = 'Create';
    }
  }
  getTemplateDetailsById(id, templateDetailId) {
    this.accountService.getTemplateDetailsById(id, templateDetailId)
      .subscribe(res => {
        this.templateDetails = res;
        this.updateForm(this.templateDetails);
      });
  }
  createForm() {
    this.sectionForm = this.formbuilder.group({
      sortOrder: ['', Validators.compose([Validators.required, Validators.maxLength(5)])],
      visible: [],
      autosuggestionType: [],
      autosuggestion: [],
      sectionType: [],
      sectionSchema: [],
      custom: [],
      attachmentVisible: [],
      sectionName: [],
      schemaVersion: [],
    });
  }
  updateForm(templateDetails) {
    this.templeteDetailId = templateDetails.id
    this.sectionForm.patchValue({
      sortOrder: templateDetails.sortOrder,
      visible: templateDetails.visible,
      autosuggestionType: templateDetails.autosuggestionType,
      sectionType: templateDetails.sectionType,
      sectionSchema: JSON.stringify(templateDetails.sectionSchema),
      custom: templateDetails.custom,
      attachmentVisible: templateDetails.attachmentVisible,
      sectionName: templateDetails.sectionName,
      schemaVersion: templateDetails.schemaVersion,
      autosuggestion: templateDetails.autosuggestion,
    });
    this.testJson = templateDetails.sectionSchema;
    if (templateDetails.sectionSchema) {
      this.JsonObject = JSON.stringify(templateDetails.sectionSchema);
    }
  }
  onChange() {
    // Handle change event
    console.log('Slide toggle changed:', this.sectionForm.get('visible').value);
  }
  Submit() {
    if (this.type === 'edit') {
      const postdata = {
        template: {
          id: this.tempId
        },
        sortOrder: this.sectionForm.get('sortOrder').value,
        visible: this.sectionForm.get('visible').value,
        autosuggestionType: this.sectionForm.get('autosuggestionType').value,
        sectionType: this.sectionForm.get('sectionType').value,
        custom: this.sectionForm.get('custom').value,
        attachmentVisible: this.sectionForm.get('attachmentVisible').value,
        sectionName: this.sectionForm.get('sectionName').value,
        schemaVersion: this.sectionForm.get('schemaVersion').value,
        autosuggestion: this.sectionForm.get('autosuggestion').value,
      };
      if (this.sectionForm.get('sectionSchema').value) {
        this.validateData(this.sectionForm.get('sectionSchema').value).then(() => {
          if (this.isJsonValid) {
            postdata['sectionSchema'] = JSON.parse(this.sectionForm.get('sectionSchema').value)
            this.accountService.updateDetails(this.accId, this.templeteDetailId, postdata)
              .subscribe(res => {
                this.api_success = 'Section Details updated successfully';
                setTimeout(() => {
                  this.matDialog.close();
                }, 2000);
              },
                (error) => {
                  this.api_error = error.error;
                  this.btndisabled = false;
                });
          }
          else {
            this.api_error = 'Invalid Json';
            this.btndisabled = false;
          }
        });
      }
      else if (this.sectionForm.get('sectionSchema').value === '' || this.sectionForm.get('sectionSchema').value === undefined) {
        this.accountService.updateDetails(this.accId, this.templeteDetailId, postdata)
          .subscribe(res => {
            this.api_success = 'Section Details updated successfully';
            setTimeout(() => {
              this.matDialog.close();
            }, 2000);
          },
            (error) => {
              this.api_error = error.error;
              this.btndisabled = false;
            });
      }
    } else if (this.type === 'add') {
      const postdata = {
        template: {
          id: this.tempId
        },
        sortOrder: this.sectionForm.get('sortOrder').value,
        visible: this.sectionForm.get('visible').value,
        autosuggestionType: this.sectionForm.get('autosuggestionType').value,
        sectionType: this.sectionForm.get('sectionType').value,
        custom: this.sectionForm.get('custom').value,
        attachmentVisible: this.sectionForm.get('attachmentVisible').value,
        sectionName: this.sectionForm.get('sectionName').value,
        schemaVersion: this.sectionForm.get('schemaVersion').value,
        autosuggestion: this.sectionForm.get('autosuggestion').value,
        sectionSchema: this.sectionForm.get('sectionSchema').value,
      };
      this.btndisabled = true;
      this.api_error = '';
      this.accountService.createDetails(this.accId, postdata)
        .subscribe(res => {
          this.api_success = 'Section Details created successfully';
          setTimeout(() => {
            this.matDialog.close();
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.btndisabled = false;
          });
    }
  }
  validateData(data) {
    if (data) {
      return new Promise((resolve, reject) => {
        try {
          JSON.parse(data);
          this.isJsonValid = true;
        } catch (error) {
          console.error('Invalid JSON:', error);
          this.isJsonValid = false;
        }
        resolve(true);
      },
      );
    }
  }
  limitCharactersOrder(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 5) {
      input.value = value.slice(0, 5);
      this.sectionForm.controls['sortOrder'].setValue(value.slice(0, 5));
    }
  }
  limitCharactersType(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 40) {
      input.value = value.slice(0, 40);
      this.sectionForm.controls['autosuggestionType'].setValue(value.slice(0, 40));
    }
  }
  limitCharactersName(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 40) {
      input.value = value.slice(0, 40);
      this.sectionForm.controls['sectionName'].setValue(value.slice(0, 40));
    }
  }
   limitCharactersVersion(event: any) {
    const input = event.target;
    const value = input.value;

    if (value.length > 15) {
      input.value = value.slice(0, 15);
      this.sectionForm.controls['schemaVersion'].setValue(value.slice(0, 15));
    }
  }
  
}
